import React from 'react';
import { Loader2, Bot, StopCircle } from 'lucide-react';

interface LoadingIndicatorProps {
  loopingStatus?: string;
  onStop: () => void;
}

/**
 * Component for showing the agent loop loading indicator
 */
export function LoadingIndicator({ loopingStatus, onStop }: LoadingIndicatorProps) {
  return (
    <div className="flex gap-3">
      <div className="w-8 h-8 rounded-full bg-surface-700 flex items-center justify-center">
        <Bot className="w-4 h-4 text-text-muted" />
      </div>
      <div className="bg-surface-800 rounded-lg px-3 py-2 flex items-center gap-2">
        <Loader2 className="w-4 h-4 animate-spin text-text-muted" />
        {loopingStatus && (
          <span className="text-sm text-text-muted">{loopingStatus}</span>
        )}
        <button
          onClick={onStop}
          className="ml-2 p-1 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded transition-colors"
          title="Stop agent"
        >
          <StopCircle className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
